import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { __ } from '@wordpress/i18n';
import { contextConnect, useContextSystem } from '@wp-g2/context';
import { cx } from '@wp-g2/styles';
import React from 'react';
import { CardHeader } from '../Card';
import * as styles from './Modal.styles';
import ModalCloseButton from './ModalCloseButton';
import ModalTitle from './ModalTitle';

function ModalHeader(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'ModalHeader'),
      children = _useContextSystem.children,
      className = _useContextSystem.className,
      _useContextSystem$clo = _useContextSystem.closeLabel,
      closeLabel = _useContextSystem$clo === void 0 ? __('Close') : _useContextSystem$clo,
      _useContextSystem$sho = _useContextSystem.showCloseLabel,
      showCloseLabel = _useContextSystem$sho === void 0 ? true : _useContextSystem$sho,
      title = _useContextSystem.title,
      otherProps = _objectWithoutProperties(_useContextSystem, ["children", "className", "closeLabel", "showCloseLabel", "title"]);

  var classes = cx(styles.ModalHeader, className);
  return /*#__PURE__*/React.createElement(CardHeader, Object.assign({}, otherProps, {
    className: classes,
    ref: forwardedRef
  }), children, /*#__PURE__*/React.createElement(ModalTitle, null, title), /*#__PURE__*/React.createElement(ModalCloseButton, {
    closeLabel: closeLabel,
    showCloseLabel: showCloseLabel
  }));
}

export default contextConnect(ModalHeader, 'ModalHeader');